<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemToSave?.id ? "Modification "+title : "Enregistrement "+title}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">
                <div class="row">
                    
                    <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Code:
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input"  [disabled]="itemToSave.id" placeholder="Code" autocomplete="off"
                          [(ngModel)]="itemToSave.code" name="code" autocomplete="off" type="text" />
                  </div> -->
                  <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Codification:
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input"   placeholder="Codification" autocomplete="off"
                          [(ngModel)]="itemToSave.codification" name="codification" autocomplete="off" type="text" />
                  </div> -->
                  
               
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                    <label>Type :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select (change)="onChangeTypeAvenant()" [(ngModel)]="itemToSave.type_avenant_id"
                        placeholder="Choisissez " name="type_avenant_id" id="type_avenant_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsTypeAvenant" [value]="item.id">{{ item?.libelle }}
                        </ng-option>
                    </ng-select>
                </div>
                  
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                    <label>Police :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select  [(ngModel)]="itemToSave.police_id"
                        placeholder="Choisissez " name="police_id" id="police_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsPolice" [value]="item.id">{{ item?.libelle }}
                        </ng-option>
                    </ng-select>
                </div>
                
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Libellé :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                            [(ngModel)]="itemToSave.libelle" name="libelle" autocomplete="off" type="text" />
                    </div>
                  

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1">
                    <label>Date d'effet :
                        <span class="required_champs">*</span>
                    </label>
                    <!-- <input
              onkeydown="return false" -->
                    <input type="text" placeholder="Date d'effet"
                        autocomplete="off" class="form-control" bsDatepicker [bsConfig]="{
                dateInputFormat: 'DD/MM/YYYY',
                containerClass: 'theme-dark-blue'
              }" [(ngModel)]="itemToSave.date_effet" name="date_effet" />
                </div>
                    <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                      <label>Mode création :
                          <span class="required_champs">*</span>
                      </label>
                      <ng-select disabled [(ngModel)]="itemToSave.mode_avenant"
                          placeholder="Choisissez " name="mode_avenant" id="mode_avenant" [multiple]="false"
                          [closeOnSelect]="true">
                          <ng-option *ngFor="let item of itemsModeCreationAvenant" [value]="item.code">{{ item?.libelle }}
                          </ng-option>
                      </ng-select>
                  </div> -->

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                    <label>Description :
                        <span class="required_champs">*</span>
                    </label>
                    <!-- <input disabled class="form-control custom-input" placeholder="Description" autocomplete="off"
                        [(ngModel)]="itemToSave.description" name="description" autocomplete="off" type="text" /> -->
                        <textarea [(ngModel)]="itemToSave.description" name="description" class="form-control" ></textarea>
                </div>
                    
                </div>
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <button type="button" (click)="confirmSaveItem(itemToSave)" class="btn btn-md custom_btn_primary pull-right"
            [class.auth-spinner]="loading" [disabled]="loading">
            Sauvegarder
        </button>

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>